export const createProductSlice = (set, get) => ({
  products: [],
  productSearchName: '',
  productSearchCategory: '',
  productCurrentPage: 1,
  productPageSize: 10,
  productHasLoaded: false,
  productLastFetched: null,
  productIsLoading: false,

  setProducts: (products) => set({ products, productCurrentPage: 1 }),
  setProductSearchName: (name) => set({ productSearchName: name, productCurrentPage: 1 }),
  setProductSearchCategory: (category) => set({ productSearchCategory: category, productCurrentPage: 1 }),
  setProductCurrentPage: (page) => set({ productCurrentPage: page }),
  setProductPageSize: (size) => set({ productPageSize: size, productCurrentPage: 1 }),
  resetProductFilters: () => set({ productSearchName: '', productSearchCategory: '', productCurrentPage: 1 }),

  // Mark products as loaded
  setProductsLoaded: (loaded) => set({ productHasLoaded: loaded, productLastFetched: loaded ? Date.now() : null }),

  // Initialize products from API
  initializeProducts: async (fetchProductsFn, forceRefresh = false) => {
    const state = get();
    // Return if already loading
    if (state.productIsLoading) {
      return state.products;
    }
    // Return cached if not forcing refresh and already loaded
    if (!forceRefresh && state.productHasLoaded) {
      return state.products;
    }
    
    try {
      set({ productIsLoading: true });
      const response = await fetchProductsFn();
      const products = response.products || [];
      set({ 
        products, 
        productHasLoaded: true, 
        productLastFetched: Date.now(),
        productIsLoading: false 
      });
      return products;
    } catch (error) {
      set({ productIsLoading: false });
      console.error('Error loading products:', error);
      throw error;
    }
  },

  getFilteredProducts: (state) => {
    if (!state.productSearchName && !state.productSearchCategory) {
      return state.products;
    }

    const nameQuery = state.productSearchName.toLowerCase();
    const categoryQuery = state.productSearchCategory.toLowerCase();

    return state.products.filter((product) => {
      const matchName = !nameQuery || product.name.toLowerCase().includes(nameQuery);
      const matchCategory = !categoryQuery || product.category.toLowerCase().includes(categoryQuery);
      return matchName && matchCategory;
    });
  },

  // Get paginated filtered products
  getPaginatedProducts: (state) => {
    const filtered = state.getFilteredProducts ? state.getFilteredProducts(state) : state.products;
    const { productCurrentPage, productPageSize } = state;
    const startIndex = (productCurrentPage - 1) * productPageSize;
    const endIndex = startIndex + productPageSize;
    
    return {
      data: filtered.slice(startIndex, endIndex),
      total: filtered.length,
      page: productCurrentPage,
      pageSize: productPageSize,
      pages: Math.ceil(filtered.length / productPageSize)
    };
  },

  // Add product to store
  addProduct: (product) => set((state) => ({
    products: [product, ...state.products]
  })),

  // Update product in store
  updateProductInStore: (id, updatedProduct) => set((state) => ({
    products: state.products.map(p => p.id === id ? updatedProduct : p)
  })),

  // Remove product from store
  removeProductFromStore: (id) => set((state) => ({
    products: state.products.filter(p => p.id !== id)
  }))
});
